import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';

import SettingsForm from '../components/SettingsForm';
import { SettingProvider, useSettingStore } from '../store';

function ThemeSettingsForm() {
  const { settings, useLoad, useSubmit } = useSettingStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad()

  const handleSubmit = useSubmit()

  const handleSubmitThemeSettings = async payload => {
    try {
      await handleSubmit(payload)
      handleSuccess('Success', 'Theme settings saved.');
    } catch (error) {
      handleError('Error', 'Theme settings was not saved.');
    }
  }

  return <>
    <FormWrapper title="Theme Settings">
      <SettingsForm
        settingKey={'config'}
        title={"Theme Settings"}
        options={settings.theme_settings?.theme_options}
        settings={settings}
        onSubmit={handleSubmitThemeSettings}
      />
    </FormWrapper>
  </>
}

export default function ThemeSettingFormLayout() {
  return <SettingProvider>
    <ThemeSettingsForm />
  </SettingProvider>;
}
